<template>
<div class="order">
    <headerNav title="确认订单" />
    <div class="oopd">
        <div class="oo">
            <div class="ooad">
                <div class="oo-left">
                    <van-icon class="main-list-icon-right" :size="26" :color="$abctheme.basecolor" class-prefix="abc-icon" name="diqu" />
                </div>
                <div v-if="!addressData.receiverState" @click="gotoaddress">
                    <div class="tit">暂无地址,点击前往添加地址</div>
                </div>
                <div v-else @click="gotoaddress">
                    <div class="tit">
                        {{addressData.receiverName}}<span class="titphone" style="margin-right:10px">{{addressData.receiverMobile}}</span>
                        <!-- <van-tag type="primary"  v-if="addressData.isAuthCard">认证</van-tag>
                        <van-tag type="danger" v-if="!addressData.isAuthCard">未认证</van-tag> -->
                    </div>
                    <div class="stit">{{addressData.receiverState+addressData.receiverCity+addressData.receiverDistrict}}</div>
                    <div class="stit">{{addressData.receiverAddress}}</div>
                </div>
                <div class="oo-right">
                    <van-icon class="main-list-icon-left" :size="14" :color="$abctheme.basecolor" class-prefix="abc-icon" name="you" />
                </div>
            </div>

        </div>
        <div class="oo">
            <div class="oold">
                <div class="ooproduct">
                    <div class="oonj" v-for="(product,i) in goodlist" :key="i">
                        <div class="oonj-img">
                            <img :src="$baseurl+product.imageURL" />
                        </div>
                        <div class="oonj-info">
                            <div class="oonj-info-tit van-multi-ellipsis--l2">
                                <div>{{product.title}}</div>
                                <span class="price">{{linkpage.isIntegral?'积分':'￥'}} {{product.price}}</span>
                            </div>
                            <div v-if="product.isSeaProduct" :style="{color:$abctheme.basecolor}">
                                【海外产品】
                            </div>
                            <div class="oonj-info-stitc">
                                <span>{{product.desc}}</span>
                                <span>x{{product.quantity}}</span>
                            </div>
                            <div class="oonj-info-stit" v-if="product.cartonSize">
                                <span>箱规</span>
                                <span>{{product.cartonSize+product.unit+"/箱"}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="oomain">
                    <div class="oomain-info">
                        <div class="oomain-info-dd">
                            <div class="ft">配送方式</div>
                            <div class="ft-main">普通配送方式</div>
                            <div class="ft-icon">
                                <van-icon class="main-list-icon-left" :size="14" :color="$abctheme.basecolor" class-prefix="abc-icon" name="you" />
                            </div>
                        </div>
                        <div class="oomain-info-dd">
                            <div class="ft">订单备注</div>
                            <input placeholder="订单备注" v-model="PhoneTradeDto.buyerMessage" />
                        </div>
                        <div class="oomain-info-dd" v-if="linkpage.couponMain && linkpage.couponMain.coupons">
                            <div class="ft">优惠券</div>
                            <div class="ft-main" @click="showPicker = true" >{{linkpage.couponMain.coupons[selectCouponIndex].title}}</div>
                            <div class="ft-icon" @click="showPicker = true" >
                                <van-icon class="main-list-icon-left" :size="14" :color="$abctheme.basecolor" class-prefix="abc-icon" name="you" />
                            </div>
                        </div>
                        <div class="oomain-info-dd" @click="newAwardShow=true">
                            <!--v-if="linkpage.newAwardMain && linkpage.newAwardMain.length==2"-->
                            <div class="ft">新人奖励</div>
                            <div class="ft-main">{{linkpage.newAwardMain.details[linkpage.newAwardMain.selectId].title}}</div>
                            <div class="ft-icon">
                                <van-icon class="main-list-icon-left" :size="14" :color="$abctheme.basecolor" class-prefix="abc-icon" name="you" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="oofooter">
                    <div>
                        运费：<span class="price">{{linkpage.postFee?'￥'+linkpage.postFee:'免运费'}}</span>
                    </div>
                    <div v-if="!linkpage.isIntegral">
                        <span class="num">共{{totalnum}}件</span>小计：<span class="price">￥{{linkpage.realPayPrice}}</span>
                        
                    </div>
                    <div v-else>
                        <span class="num">共{{totalnum}}件</span>小计：<span class="price">积分 {{linkpage.realPayPrice-linkpage.postFee}}</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <van-submit-bar :currency="linkpage.isIntegral?'积分':'￥'" :price="(linkpage.isIntegral?linkpage.realPayPrice-linkpage.postFee:linkpage.realPayPrice)*100" button-text="提交订单" :label="linkpage.isIntegral?'实付积分：':'实付金额：'" @submit="onSubmit" :loading="isload">
        <template #tip v-if="linkpage.isSeaTrade&&!addressData.isAuthCard">
            <div>
                你的收货地址还未认证不支持海外产品, <span @click="gotoaddress" style="color:blue">修改地址</span>
            </div>
        </template>
    </van-submit-bar>
    <van-action-sheet v-model="newAwardShow" :actions="linkpage.newAwardMain.details" @select="onSelectnewAward" />
    <van-popup v-model="showPicker" round position="bottom" v-if="linkpage.couponMain.coupons">
  <van-picker
    show-toolbar
    :columns="linkpage.couponMain.coupons"
    @cancel="showPicker = false"
    @confirm="onConfirmcoupon"
    value-key="title"
  />
</van-popup>
</div>
</template>

<script>
import request from "@/config/ajax";
import Util from "@/config/Util";
export default {
    data() {
        return {
            type: "add1",
            goodlist: [],
            totalMoney: 0,
            goodMoney: 0,
            payment: 0,
            isload: false,
            linkpage: {
                isFirst: 0,
                IsCar: false,
                realPayPrice: 0,
                skus: [],
                secInfo: {},
                revInfo: {}
            },
            addressData: undefined,
            PhoneTradeDto: {
                buyerNick: '',
                receiverName: '',
                receiverState: '',
                receiverCity: '',
                receiverDistrict: '',
                receiverAddress: '',
                receiverMobile: '',
                buyerMessage: '',
                activeDetailId: '',
                activeId: 0,
                productId: 0,
                productSpecId: 0,
                phoneTradeDetails: []
            },
            newAwardShow: false,
            showPicker:false,
            selectCouponIndex:0

        }
    },
    computed: {
        totalnum() {

            if (this.linkpage && this.linkpage.skus) {
                return this.linkpage.skus.reduce((total, item) => {
                    return total + item.num;
                }, 0);
            } else {
                return 0;
            }
        }
    },
    created() {
        if (!Util.abp.session.userId) {
            this.$router.push({
                path: "/login/password"
            });
        } else {
            var option = this.$route.query;
            console.log(option)
            if (option.secid != null && option.secdetailid != null) {
                //表示来自秒杀商品
                this.linkpage.secInfo.OrderActiveId = option.secid;
                this.linkpage.secInfo.ActiveDetailId = option.secdetailid
            }
            if (option.createType == 0) {
                this.linkpage.IsCar = true; //表示订单来自购物车跳转过来的
            }

            var goodinfostr = localStorage.getItem("createorderinfo");
            console.log(goodinfostr);
            this.goodlist = JSON.parse(goodinfostr);
            console.log(this.goodlist);
            this.goodlist.forEach(x => {
                this.linkpage.skus.push({
                    sku: x.sku,
                    num: x.quantity,
                    cartonSize: x.cartonSize
                })
                if (x.isServer) {
                    this.isServer = true;
                }
            })
            console.log(this.linkpage);
            this.getmyAddress();
            if (!this.linkpage.revInfo) {
                this.linkpage.revInfo = {};
            }

            this.abp.event.on("app.UserCreateOrder", x => {
                this.isload = false
                if (x.status != 0) {
                    this.$toast(x.errMsg);
                } else {
                    var tid = x.result;
                    this.$router.push({
                        path: '/pay',
                        query: {
                            tid: tid,
                            code: ''
                        }
                    });
                }
            })

            this.abp.event.on("app.SecCreateOrder", x => {
                this.isload = false
                if (x.status != 0) {
                    this.$toast(x.errMsg);
                } else {
                    var tid = x.result;
                    this.$router.push({
                        path: '/pay',
                        query: {
                            tid: tid,
                            code: ''
                        }
                    });
                }
            })

        }

    },
    methods: {
        getmyAddress() {
            let id=localStorage.getItem('changeaddress') || 0;
            localStorage.setItem('changeaddress',''); 
            request.post('/api/services/app/PhoneUser/QueryDefaultAddress?id='+id).then(x => {
                this.addressData = x.result;
                this.linkpage.revInfo.receiverState = this.addressData.receiverState;
                this.updateAddress();
            })
        },
        gotoaddress() {
            this.$router.push({
                name: 'address',
                params: {
                    sourece: 1
                }
            });
        },
        updateAddress() {
            this.linkpage.isFirst = 0;
            this.Async_Linkage();
        },
        //加载地址
        checkaddress(item) {
            this.addressData = item;
            setTimeout(() => {
                this.linkpage.revInfo.receiverState = this.addressData.receiverState;
                this.updateAddress();
            }, 10)
        },
        Async_Linkage() {
            request.post('/api/services/app/PhoneTrade/Async_Linkage', this.linkpage).then(x => {
                this.linkpage = x.result;
                this.linkpage.couponMain.selectCoupon = undefined;

                if (this.linkpage.couponMain.coupons) {
                    this.linkpage.couponMain.coupons = this.linkpage.couponMain.coupons.map(x => {
                        if (x.id != 0) {
                            x.title = x.minSellPrice > 0 ?
                                `满${x.minSellPrice}省${x.price}元` :
                                `无门槛省${x.price}元`;
                        } else {
                            x.title = '不使用优惠券';
                        }

                        return x;
                    })
                    if (this.linkpage.couponMain.selectId >= 0) {
                        this.linkpage.couponMain.selectCoupon = this.linkpage.couponMain.coupons.filter(x => x.id == this.linkpage.couponMain
                            .selectId)[0];

                        //console.log(this.linkpage.couponMain.coupons)
                        this.$forceUpdate();
                    }
                }

                this.linkpage.isFirst++; //方便后续的调用查询更快
            })
        },
        onSubmit() {

            if (!this.addressData.receiverState || !this.addressData.receiverDistrict || !this.addressData.receiverState || !this.addressData.receiverCity || !this.addressData.receiverMobile) {
                this.$toast("请选择个人地址");
                return;
            }

            if(this.linkpage.isSeaTrade&&!this.addressData.isAuthCard)
            {
                this.$toast("您的收货地址还未认证不支持海外产品");
                return;
            }

            let useraddress = this.addressData;

            let currgooodlist = this.goodlist;
            this.PhoneTradeDto.revInfo = {};
            if (this.addressData.receiverName) {
                this.PhoneTradeDto.revInfo.receiverAddress = useraddress.receiverAddress;
                this.PhoneTradeDto.revInfo.receiverCity = useraddress.receiverCity;
                this.PhoneTradeDto.revInfo.receiverDistrict = useraddress.receiverDistrict;
                this.PhoneTradeDto.revInfo.receiverState = useraddress.receiverState;
                this.PhoneTradeDto.revInfo.receiverMobile = useraddress.receiverMobile;
            }
            this.PhoneTradeDto.revInfo.receiverName = useraddress.receiverName || Util.abp.userInfo.dealerName;
            this.PhoneTradeDto.revInfo.buyerNick = Util.abp.userInfo.dealerName;
            this.PhoneTradeDto.revInfo.buyerMessage = this.PhoneTradeDto.buyerMessage;
            this.PhoneTradeDto.revInfo.cardNo=useraddress.cardNo;
            this.PhoneTradeDto.revInfo.isAuthCard=useraddress.isAuthCard;
            this.PhoneTradeDto.revInfo.picPath=useraddress.picPath;
            //console.log(this.PhoneTradeDto.revInfo);
            this.linkpage.revInfo = this.PhoneTradeDto.revInfo;
            this.PhoneTradeDto.phoneTradeDetails = []; //从购物车中取产品
            currgooodlist.forEach(x => {
                this.PhoneTradeDto.phoneTradeDetails.push({
                    sku: x.sku,
                    num: x.quantity
                });
            })
            //从购物车，生成订单
            var url = '/api/services/app/PhoneTrade/Confirm_order';
            // if (this.createType == 1) {
            // 	//立即支付
            // 	url = '/api/services/app/PhoneTrade/OnceCreateOrder';
            // }
            this.isload = true;
            if (this.linkpage.secInfo.orderActiveId != null) {
                url = '/api/services/app/PhoneSecManage/BuyGoods';
                this.PhoneTradeDto.activeId = this.linkpage.secInfo.orderActiveId;
                this.PhoneTradeDto.activeDetailId = this.linkpage.secInfo.activeDetailId;
                this.PhoneTradeDto.sku = this.linkpage.skus[0].sku;
                this.PhoneTradeDto.num = this.linkpage.skus[0].num;
                this.PhoneTradeDto.couponRecordId = this.linkpage.couponMain.selectId;
                if (this.linkpage.moneyOffMain.selectId == 1) {
                    this.PhoneTradeDto.MoneyOffDetailId = this.linkpage.moneyOffMain.details[1].moneyOffIds[0] //参与的满减
                }
                setTimeout(() => {
                    request.post(url, this.PhoneTradeDto).then().catch(() => {
                        this.isload = false
                    });
                }, 300)
            } else {
                setTimeout(() => {
                    request.post(url, this.linkpage).then().catch(() => {
                        this.isload = false
                    });
                }, 300)
            }
        },
        bindPickerChange(e) {
            this.linkpage.moneyOffMain.selectId = parseInt(e.target.value)
            this.Async_Linkage();
            // this.$abp.lunrequest.post('/api/services/app/PhoneTrade/Async_Linkage', this.linkpage).then(x => {
            // 	this.linkpage = x.result;
            // 	this.linkpage.isFirst++; //方便后续的调用查询更快
            // })
        },
        bindPickerChangecoupon(e) {
            this.linkpage.couponMain.selectId = this.linkpage.couponMain.coupons[parseInt(e.target.value)].id;
            this.Async_Linkage();
        },
        onSelectnewAward(item) {
            this.linkpage.newAwardMain.selectId = item.id;
            this.newAwardShow = false;
            this.Async_Linkage();
        },
         onConfirmcoupon(e,index){
            this.linkpage.couponMain.selectId=e.id;
            this.Async_Linkage();
            this.selectCouponIndex=index;
            this.showPicker=false
        }

    },
    activated() {
        //根据key名获取传递回来的参数，data就是map
        this.$on('changeaddress', function (data) {
            //console.log('返回触发数据:',data);
            //赋值给首页的附近医院数据模型
            this.checkaddress(data);
        }.bind(this));
    }
};
</script>

<style lang="scss" scoped>
.order{
    margin-bottom: 50px;
}
.oopd {
    font-size: 12px;
}

.oo {
    margin: 5px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 1px 1px 3px #c3c3c3;
}

.ooad {
    position: relative;
    padding: 10px 50px 10px 50px;
}

.oo-left {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translate(0, -50%);
}

.oo-right {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translate(0, -50%);
}

.tit {
    font-size: 14px;
}

.titphone {
    margin-left: 10px;
    font-size: 12px;
    color: #ababab;
}

.oold {
    padding: 10px;
}

.oonj {
    position: relative;
    min-height: 90px;
    padding-left: 90px;
}

.oonj-img {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    width: 80px;
    height: 80px;
}

.oonj-img img {
    width: 100%;
    height: auto;
    border-radius: 4px;
}

.oonj-info {}

.oonj-info-tit {
    font-size: 14px;
    margin-bottom: 5px;
    width: calc(100% - 90px);
    word-break: break-all;
}

.oonj-info-tit .price {
    position: absolute;
    right: 0;
    top: 0;
}

.oonj-info-stitc {
    color: #b1b1b1;
    margin-bottom: 5px;
    font-size: 12px;
}

.oonj-info-stitc span:last-child {
    float: right;
}

.oonj-info-stit {
    color: #b1b1b1;
    margin-bottom: 5px;
    font-size: 12px;
}

.oomain {}

.oomain-info {
    font-size: 13px;
    margin-bottom: 10px;
}

.oomain-info-dd {
    border-bottom: 1px solid #f5f5f5;
    padding: 10px 0;
    position: relative;
}

.ft {
    display: inline-block;
    width: 80px;
}

.ft-main {
    display: inline-block;
    width: calc(100% - 120px);
}

.ft-icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
}

.oomain-info-dd input {
    width: calc(100% - 100px);
    border: 0;
}

.oomain-info-dd:last-child {
    border: 0;
}

.oofooter {
    text-align: right;
}

.oofooter .num {
    margin-right: 5px;
}

.oofooter .price {
    color: red;
}
</style>
